<template>
  <div class="footer">
    <div class="footer-box">
      <div class="logo-box">
        <div class="logo-name">
          <img src="../assets/logo.png" class="logo-1" />
          <p>VISTA TECH</p>
        </div>
        <div class="text">
          <img src="../assets/menu-email.png" alt="" />
          Contact Us <br />
          hugh@vista-hk.com
        </div>
        <div class="text">
          <img src="../assets/menu-address.png" alt="" />
          Address <br />
          424 Balestier Rd, 02-11 Giffard Mansion Singapore 32981
        </div>
      </div>
      <div class="connect">
        <input type="email" placeholder="Email here*" />
        <div class="btn" @click="send()">
          Send Now
        </div>
      </div>
    </div>

    <div class="copyright">
      © 2024 Relume. All rights reserved.
    </div>
  </div>
</template>
<style lang="less" scoped>
.footer {
  .footer-box {
    height: 240px;
    background: #101527;
    padding: 20px 360px 20px 360px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .logo-box {
      width: 400px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      margin-top: 30px;
      .logo-name {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        .logo-1 {
          width: 46px;
          height: 37px;
          margin-right: 14px;
        }
        p {
          font-family: Prompt, Prompt;
          font-weight: 800;
          font-size: 26px;
          color: #ffffff;
        }
      }

      .text {
        font-family: Krub, Krub;
        font-weight: 500;
        font-size: 14px;
        color: #ffffff;
        margin-top: 20px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        img {
          width: 50px;
          height: 50px;
          margin-right: 14px;
        }
      }
    }
    .connect {
      input {
        width: 290px;
        height: 60px;
        line-height: 60px;
        padding-left: 20px;
        font-family: League Spartan, League Spartan;
        font-weight: 400;
        font-size: 20px;
        color: #ffffff;
        background: unset;
        border: 1px solid #ffffff;
      }
      .btn {
        width: 148px;
        height: 60px;
        line-height: 60px;
        text-align: center;
        background: #0459d8;
        border-radius: 10px;
        font-family: Krub, Krub;
        font-weight: 600;
        font-size: 16px;
        color: #ffffff;
        margin-top: 20px;
      }
    }
  }
  .copyright {
    height: 76px;
    background: #000;
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 16px;
    color: #ffffff;
    line-height: 76px;
    text-align: center;
  }
}
</style>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    send() {
      alert("send success");
    },
    selectMenu(value) {
      this.index = value;
      if (value == this.step) {
        return;
      }
      switch (value) {
        case 1:
          this.$router.push({ path: "/" });
          break;
        case 2:
          this.$router.push({ path: "about" });
          break;
        case 3:
          this.$router.push({ path: "services" });
          break;
        case 4:
          this.$router.push({ path: "offers" });
          break;
        case 5:
          this.$router.push({ path: "contact" });
          break;
        // case 5: this.$router.push({ path: "cooperate" }); break;
        default:
          this.$router.push({ path: "/" });
          break;
      }
    },
  },
};
</script>
